import { getNestedBoolean, useConfig } from '@/utils/useConfig';
import { Role } from '@auth/user';
import FuseLoading from '@fuse/core/FuseLoading';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';
import { Navigate } from 'react-router';

const WebRar = lazy(() => import('./WebRar'));

const ConfigCheck = () => {
    const { config, loading, error } = useConfig('webrar_config');

    if (loading) {
        return <FuseLoading />;
    }

    if (error) {
        console.warn('WebRar config loading error:', error);
        return <WebRar />;
    }

    if (getNestedBoolean(config, 'disablePage') === true) {
        return <Navigate to="/404" replace />;
    }

    return <WebRar />;
};

const WebRarRoute: FuseRouteItemType = {
    path: 'webrar/:page/:subpage?',
    element: <ConfigCheck />,
    auth: [Role.Domain_Manager, Role.Admin, Role.Technical_Support],

    settings: {
        layout: {
            config: {
                toolbar: {
                    title: 'WebRar',
                    showCrumbs: false,
                    helpName: 'Web-Rar',

                }
            }
        }
    }
};

export default WebRarRoute;
